import { PaginationResults } from './PaginationResults';

export default PaginationResults;
